import { queryKeys } from "@/constants/queryKeyFactory";
import { useQuery } from "@/hooks/api";
import { ApiResponse, QueryOptions } from "@/interfaces/api.interface";
import reportService, { IReport, IReportParams } from "@/services/report.service";

export function useReports(
  params: IReportParams,
  options: QueryOptions = {}
) {
  return useQuery<ApiResponse<IReport[]>>(
    ['reports', params],
    () => reportService.getReports(params),
    {
      ...options,
      refetchOnWindowFocus: false,
      enabled: !!params.projectId && (options.enabled !== false),
    }
  );
}
